"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveWalletDisplayedBusinessFee = resolveWalletDisplayedBusinessFee;
exports.readAbsorbedCcFeeFromPaymentMetadata = readAbsorbedCcFeeFromPaymentMetadata;
/** Round money to 2 decimal places (banker's display, not accounting midpoints). */
function roundMoney2(value) {
    return Math.round((Number(value) || 0) * 100) / 100;
}
/**
 * Wallet Fee column: Handshake service fee + any CC markup absorbed by the business.
 * Net already reflects both deductions; Fee must include both so Gross − Fee = Net.
 */
function resolveWalletDisplayedBusinessFee(params) {
    const handshake = Math.max(0, Number(params.handshakeFeeAmountByBusinessCaptured ?? 0) || 0);
    const absorbed = Math.max(0, Number(params.absorbedCcFee ?? 0) || 0);
    return roundMoney2(handshake + absorbed);
}
/** Read cumulative absorbed CC fee from invoice payment metadata (Nucleus absorb path). */
function readAbsorbedCcFeeFromPaymentMetadata(paymentMetadata) {
    return Math.max(0, Number(paymentMetadata?.absorbed_cc_fee ?? 0) || 0);
}
